import React, { useState } from 'react';
import { api } from '../../api/client';
import './chatTheme.css';

export function ChatReportBuilder() {
  const [form, setForm] = useState({
    tipo: 'EXECUTIVO',
    publico: 'PREFEITURA',
    periodo: '30d',
    formato: 'PDF',
  });
  const [result, setResult] = useState<{ id?: string; status?: string; arquivoUrl?: string } | null>(null);

  const generate = async () => {
    const res = await api.post('/chat-interno/relatorios', form);
    setResult(res.data);
  };

  return (
    <div className="ac-chat-v8-panel">
      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Gerador de relatório</h3>
        <div style={{ display: 'grid', gap: 9, marginTop: 12 }}>
          <select className="ac-chat-v8-select" value={form.tipo} onChange={(e) => setForm((p) => ({ ...p, tipo: e.target.value }))}>
            <option value="EXECUTIVO">Executivo</option>
            <option value="OPERACIONAL">Operacional</option>
            <option value="ESCOLA">Por escola</option>
            <option value="CATEGORIA">Por categoria</option>
            <option value="SLA">SLA</option>
            <option value="SATISFACAO">Satisfação</option>
          </select>
          <select className="ac-chat-v8-select" value={form.publico} onChange={(e) => setForm((p) => ({ ...p, publico: e.target.value }))}>
            <option value="PREFEITURA">Prefeitura</option>
            <option value="SECRETARIA">Secretaria</option>
            <option value="ESCOLA">Escola</option>
            <option value="OPERACAO">Operação</option>
          </select>
          <select className="ac-chat-v8-select" value={form.periodo} onChange={(e) => setForm((p) => ({ ...p, periodo: e.target.value }))}>
            <option value="7d">7 dias</option>
            <option value="30d">30 dias</option>
            <option value="90d">90 dias</option>
            <option value="ano">Ano atual</option>
          </select>
          <select className="ac-chat-v8-select" value={form.formato} onChange={(e) => setForm((p) => ({ ...p, formato: e.target.value }))}>
            <option value="PDF">PDF</option>
            <option value="XLSX">XLSX</option>
            <option value="CSV">CSV</option>
          </select>
          <button className="ac-chat-action-btn is-success" onClick={generate}>Gerar relatório</button>
        </div>
      </div>

      {result && (
        <div className="ac-chat-v8-card">
          <h3 className="ac-chat-command-label">Relatório solicitado</h3>
          <p className="ac-chat-automation-text" style={{ marginTop: 8 }}>ID: {result.id} · Status: {result.status}</p>
          {result.arquivoUrl && <a className="ac-chat-action-btn" href={result.arquivoUrl}>Baixar arquivo</a>}
        </div>
      )}
    </div>
  );
}
